// Unpublished Work © 2025-2026 Deere & Company.

import React from 'react';
import PropTypes from 'Utils/prop-type-utils';
import {connect} from 'react-redux';
import {Dialog} from '@deere/isg.component-library';
import dialogTypes from 'Ui/components/common/dialog-types';
import {closeDialog} from 'Src/ui-core/store/actions/dialogs';
import WorkboardTemplates from 'OnLabor/workboard-templates/workboard-templates';
import {WORKBOARD as WORKBOARD_BASE_PATH} from 'Common/constants/routes';

function getTemplateFromUrl(templateId) {
    const params = new URLSearchParams({
        fromTemplate: templateId
    });

    return `${WORKBOARD_BASE_PATH}/new?${params.toString()}`;
}

function AddWorkboardFromTemplateDialog(props) {
    const {
        closeAddWorkboardFromTemplateDialog,
        history,
        translations
    } = props;

    const [createFrom, setCreateFrom] = React.useState(null);

    const footerActions = React.useMemo(() => {
        return [
            {
                title: translations.CANCEL,
                onClick: () => closeAddWorkboardFromTemplateDialog(),
                variant: 'secondary'
            },
            {
                title: translations.ONLINK_ADD_WORKBOARD,
                onClick: () => {
                    history.push(getTemplateFromUrl(createFrom));
                    closeAddWorkboardFromTemplateDialog();
                },
                variant: 'primary',
                disabled: createFrom === null
            }
        ];
    }, [createFrom]);

    return (
        <Dialog
            className='gray-bg-dialog'
            closeHandler={closeAddWorkboardFromTemplateDialog}
            footerActions={footerActions}
            open={true}
            sx={{
                background: 'red'
            }}
            title={translations.ONLINK_ADD_FROM_TEMPLATE}
            width={'100%'}
        >
            <WorkboardTemplates
                disableNavbar={true}
                maxHeightOffset={232}
                selectFromTemplate={(templateId) => setCreateFrom(templateId)}
            />
        </Dialog>
    );
}

AddWorkboardFromTemplateDialog.propTypes = {
    closeAddWorkboardFromTemplateDialog: PropTypes.func,
    history: PropTypes.history,
    translations: PropTypes.translations
};

export function mapStateToProps(state) {
    return {
        translations: state.translations
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        closeAddWorkboardFromTemplateDialog() {
            dispatch(closeDialog(dialogTypes.ADD_WB_FROM_TEMPLATE));
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddWorkboardFromTemplateDialog);
